import { Fragment } from 'react';
import { defaultDoubleCurrencyDelimiter } from '../constants';
import { getFormattedCurrency } from '../formatters';
import { useCultureContext } from '../hooks';

/**
 * Additional options for formatting the value.
 *
 * @property {ReactNode} doubleCurrencyDelimiter the custom delimiter to be used instead of default for double currency
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var FormatCurrency = function FormatCurrency(_ref) {
  var children = _ref.children,
    options = _ref.options;
  var _useCultureContext = useCultureContext(),
    culture = _useCultureContext.culture;
  var _getFormattedCurrency = getFormattedCurrency(children, culture),
    currencies = _getFormattedCurrency.currencies;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: currencies.filter(Boolean).flatMap(function (value) {
      var _options$doubleCurren;
      return [/*#__PURE__*/_jsx(Fragment, {
        children: value
      }, "value-".concat(value)), /*#__PURE__*/_jsx(Fragment, {
        children: (_options$doubleCurren = options === null || options === void 0 ? void 0 : options.doubleCurrencyDelimiter) !== null && _options$doubleCurren !== void 0 ? _options$doubleCurren : defaultDoubleCurrencyDelimiter
      }, "delimiter-".concat(value))];
    }).slice(0, -1)
  });
};